import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32579706"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-left" }
const _hoisted_2 = { class: "hd-center" }
const _hoisted_3 = { class: "nav-calendar" }
const _hoisted_4 = { class: "today-date" }
const _hoisted_5 = { class: "period-calendar" }
const _hoisted_6 = { class: "hd-right" }
const _hoisted_7 = { class: "operations" }
const _hoisted_8 = { class: "dropdown" }
const _hoisted_9 = { id: "btn-dropdown" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  div: "",
  class: "drop-content",
  ref: "drop-content"
}
const _hoisted_12 = { class: "user-detail" }
const _hoisted_13 = ["src"]
const _hoisted_14 = ["title"]
const _hoisted_15 = ["title"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        class: "brand",
        to: "/",
        title: "Open Schedule"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Open Schedule")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: _normalizeClass(["hd-button", { 'is-today': _ctx.isToday && _ctx.isAgendaRoute }]),
          to: { name: _ctx.period }
        }, {
          default: _withCtx(() => [
            _createTextVNode(" hoje ")
          ]),
          _: 1
        }, 8, ["class", "to"]),
        _createVNode(_component_router_link, {
          class: "nav-prev-next",
          to: {
          name: _ctx.period,
          params: {
            day: _ctx.datePrev.getDate(),
            month: _ctx.datePrev.getMonth() + 1,
            year: _ctx.datePrev.getFullYear(),
          },
        }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, { icon: "chevron-left" })
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, {
          class: "nav-prev-next",
          to: {
          name: _ctx.period,
          params: {
            day: _ctx.dateNext.getDate(),
            month: _ctx.dateNext.getMonth() + 1,
            year: _ctx.dateNext.getFullYear(),
          },
        }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, { icon: "chevron-right" })
          ]),
          _: 1
        }, 8, ["to"]),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.dayMonthYear), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        false
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: _normalizeClass(["hd-button", {
          'selected-period': _ctx.isActivedPeriod(_ctx.Period.Day) && _ctx.isAgendaRoute,
        }]),
              to: {
          name: _ctx.Period.Day,
          params: {
            day: _ctx.current_date.getDate(),
            month: _ctx.current_date.getMonth() + 1,
            year: _ctx.current_date.getFullYear(),
          },
        }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.periods[_ctx.Period.Day]), 1)
              ]),
              _: 1
            }, 8, ["class", "to"]))
          : _createCommentVNode("", true),
        _createVNode(_component_router_link, {
          class: _normalizeClass(["hd-button", {
          'selected-period': _ctx.isActivedPeriod(_ctx.Period.Week) && _ctx.isAgendaRoute,
        }]),
          to: {
          name: _ctx.Period.Week,
          params: {
            day: _ctx.current_date.getDate(),
            month: _ctx.current_date.getMonth() + 1,
            year: _ctx.current_date.getFullYear(),
          },
        }
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.periods[_ctx.Period.Week]), 1)
          ]),
          _: 1
        }, 8, ["class", "to"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("a", {
          class: "hd-button new-appointment",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showNewAppointmentModal()))
        }, [
          _createVNode(_component_font_awesome_icon, { icon: "plus" }),
          _createTextVNode(" Novo Agendamento ")
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", _hoisted_9, [
          _createElementVNode("img", {
            src: _ctx.current_user?.picture || 'https://www.w3schools.com/howto/img_avatar.png'
          }, null, 8, _hoisted_10),
          _createElementVNode("span", null, _toDisplayString(_ctx.current_user?.name), 1)
        ]),
        _createElementVNode("ul", _hoisted_11, [
          _createElementVNode("li", _hoisted_12, [
            _createElementVNode("img", {
              src: _ctx.current_user?.picture || 'https://www.w3schools.com/howto/img_avatar.png'
            }, null, 8, _hoisted_13),
            _createElementVNode("div", null, [
              _createElementVNode("span", {
                title: _ctx.current_user?.name
              }, _toDisplayString(_ctx.current_user?.name), 9, _hoisted_14),
              _createElementVNode("span", {
                class: "text-continous",
                title: _ctx.current_user?.email
              }, _toDisplayString(_ctx.current_user?.email), 9, _hoisted_15)
            ])
          ]),
          _hoisted_16,
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: "dropdown-link",
              to: "/profile"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Perfil ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: "dropdown-link",
              to: "/config"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Configurações ")
              ]),
              _: 1
            })
          ]),
          _hoisted_17,
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: "dropdown-link",
              to: "/logout"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Sair ")
              ]),
              _: 1
            })
          ])
        ], 512)
      ])
    ])
  ], 64))
}